<template>
    <div class="popup type2" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>본인인증</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="certify">
                        <div class="find-box info">
                            <div class="box">
                                <div class="box__inner">
                                    <div class="icon"><img src="@/assets/resource/icon/phon-icon.svg" alt=""></div>
                                    <h4><span>휴대전화</span> 인증</h4>
                                    <p class="desc">본인명의 휴대전화번호</p>
                                    <div class="botton-wrap">
                                        <button type="submit" class="main-button c-main" @click="isValid">인증하기</button>
                                    </div>
                                </div>
                            </div>
                            <!-- 수정필요(11/6 아이핀 삭제) -->
                            <!-- <div class="box">
                                <div class="box__inner">
                                    <div class="icon"><img src="@/assets/resource/icon/ipin-icon.svg" alt=""></div>
                                    <h4><span>아이핀</span> 인증</h4>
                                    <p class="desc">아이핀 ID/PW</p>
                                    <div class="botton-wrap">
                                        <button type="submit" class="main-button c-main">인증하기</button>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false,
                valid: false
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
                if(!this.popupShow) this.$emit('initBirth', '')
            },
            isValid(){
                this.popupShow = false
                this.valid = true
                this.axios.get(this.api.member.encData,{
                    params: {
                        hostNm: this.$store.state.hospStore.hostName
                    }
                }).then(encResponse => {
                    const data = encResponse.data

                    this.$store.commit('setNiceType', 'join')

                    window.open('', 'popup', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');

                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
                    form.target = "popup"; // 새 창에서 요청을 보낼 수 있도록 설정

                    // 데이터 파라미터 추가
                    const encodeData = document.createElement("input");
                    encodeData.type = "hidden";
                    encodeData.name = "EncodeData";
                    encodeData.value = data.sEncData;

                    // 데이터 파라미터 추가
                    const m = document.createElement("input");
                    m.type = "hidden";
                    m.name = "m";
                    m.value = "checkplusSerivce";

                    form.appendChild(encodeData);
                    form.appendChild(m);

                    document.body.appendChild(form);
                    form.submit();

                    document.body.removeChild(form);

                })
            }
        },
    }
</script>